import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/MaskedContactDef';
import { MaskedContactRequestType } from '../Apis/MaskedContactApi';

const autoGenerateSuccess = (param: MaskedContactRequestType) => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        ...param,
      },
    },
    configResponse: {
      status: 200,
      data: param.email
        ? {
            email: '*******lin@gmail.com',
            phoneNumber: '+55 (11) *****-5642',
          }
        : {
            email: '*******lin@gmail.com',
            phoneNumber: '99',
          },
      headers: {},
    },
  };
  return validateSuccess;
};

const autoGenerateSuccessCPF = autoGenerateSuccess({
  document: {
    type: 'CPF',
    value: MocksDef.DOCUMENT_TYPE.CPF,
  },
});

const autoGenerateSuccessCPF2 = autoGenerateSuccess({
  document: {
    type: 'CPF',
    value: '76332311061',
  },
});

const autoGenerateSuccessEMAIL = autoGenerateSuccess({
  email: MocksDef.EMAIL,
});
const autoGenerateSuccessMEMBER = autoGenerateSuccess({
  memberNumber: MocksDef.MEMBER_NUMBER,
});

const generatedSuccessMocks = [
  autoGenerateSuccessCPF,
  autoGenerateSuccessCPF2,
  autoGenerateSuccessEMAIL,
  autoGenerateSuccessMEMBER,
];

const autoGenerate = (value: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body: {
            email: `${index}-${value}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};

const autoGenerateErrorsMock = () => {
  const responseError = autoGenerate(MocksDef.EMAIL);
  return [...responseError];
};

const errorsGenerated = autoGenerateErrorsMock();

const MaskedContactMocks = [...generatedSuccessMocks, ...errorsGenerated];
export default MaskedContactMocks;
